<template>
    <div class="page p-p-3">
      <TabView>
        <TabPanel header="Current Motion">
          <div v-if="motion">
            <PresidentMotionView :motion="motion" :showSpeakerState="true"/>
          </div>
          <div v-else class="empty-state">
            No active motion
          </div>
        </TabPanel>
        <TabPanel header="Motions List">
          <div v-if="currentSession">
            <MotionsList :motions="motions"/>
          </div>
          <div v-else class="empty-state">
            No active session
          </div>
        </TabPanel>
      </TabView>
    </div>
</template>

<script>
import PresidentMotionView from './PresidentMotionView.vue'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import MotionsList from './MotionsList.vue'

export default {
  name: 'PresidentsScreen',
  components: {
    PresidentMotionView,
    TabView,
    TabPanel,
    MotionsList
  },
  computed: {
    motion () {
      return this.$store.getters['motions/current']
    },
    motions () {
      if (this.currentSession) {
        return this.$store.getters['motions/forSession'](this.currentSession)
      }
      return []
    },
    currentDateStr () {
      return new Date().toLocaleDateString('en-gb',
        {weekday: 'long', month: 'long', day: 'numeric'})
    },
    currentSession () {
      // return false
      return this.$store.getters['sessions/currentOrNext']
    },
    inSession () {
      return this.$store.getters['sessions/current'] !== null &&
        this.$store.getters['sessions/current'] !== undefined
    },
    allOver () {
      return this.$store.getters['sessions/allOver']
    }
  },
  async created () {
    await this.$store.dispatch('motions/loadCurrent')
    await this.$store.dispatch('motions/load', {screen: 'rotation'})
    await this.$store.dispatch('sessions/load')
  },
  methods: {
    async load () {
      await this.$store.dispatch('motions/loadCurrent')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/motions/PresidentsScreen.vue